import { Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';

export const NoSitesContainer = styled(Flexbox)`
  ${({ theme }) => `
  flex: 1;
  background: ${theme.background.surface};
  align-items: center;
  justify-content: center;
  `}
`;

export const NoSitesCard = styled.div`
  display: flex;
  width: 660px;
  height: 468px;
  align-items: center;
  flex-direction: column;
  padding: 24px;
  justify-content: center;
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.elevation.level0};
  background: ${({ theme }) => theme.background.surface};
  gap: 20px;
`;
